export class NavigationNode {
  url: string;
  title: string;
  tooltip: string;
  hidden: boolean;
  icon: string;
  children: NavigationNode[];
  permissions: string[];
  roles: string[];
}



// WEBPACK FOOTER //
// ./src/app/core/models/navigation-node.ts